/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  collapsedSidebar: false,
  theme: {},
  sidebarHidden: [],
  menuOrder: [],
  // Funcionalidades cerradas hoy por el Calendario de Nóminas (ver components/Layout).
  bloqueosCalendario: [],
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setCollapsedSidebar: (state, { payload }) => {
      state.collapsedSidebar = payload;
    },
    resetApp: (state) => {
      state.collapsedSidebar = initialState.collapsedSidebar;
      state.theme = initialState.theme;
      state.sidebarHidden = initialState.sidebarHidden;
      state.menuOrder = initialState.menuOrder;
      state.bloqueosCalendario = initialState.bloqueosCalendario;
    },
    setTheme: (state, { payload }) => {
      state.theme = payload;
    },
    setSidebarHidden: (state, { payload }) => {
      state.sidebarHidden = payload || [];
    },
    setMenuOrder: (state, { payload }) => {
      state.menuOrder = payload || [];
    },
    setBloqueosCalendario: (state, { payload }) => {
      state.bloqueosCalendario = Array.isArray(payload) ? payload : [];
    },
  },
});

export const {
  setCollapsedSidebar,
  resetApp,
  setTheme,
  setSidebarHidden,
  setMenuOrder,
  setBloqueosCalendario,
} = appSlice.actions;

// Data Selectors
export const selectCollapsedSidebar = ({ app }) => app.collapsedSidebar;
export const selectTheme = ({ app }) => app.theme;
export const selectSidebarHidden = ({ app }) => app.sidebarHidden || [];
export const selectMenuOrder = ({ app }) => app.menuOrder || [];
// `app` se persiste (redux-persist): valida que sea arreglo para no romper con un valor viejo.
const SIN_BLOQUEOS = [];
export const selectBloqueosCalendario = ({ app }) => (
  Array.isArray(app.bloqueosCalendario) ? app.bloqueosCalendario : SIN_BLOQUEOS
);

export default appSlice.reducer;
